export default __webpack_public_path__ + "static/hiit_it_interval_timer_iphone-complete@2x-76eda79012782029da619fd89228dd55.webp";